import React, {useState} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js"
import { Button, Spin, Row, Modal, Input,Typography } from 'antd'
import instance from '../utils/API';
import { useHistory } from 'react-router-dom'
import { orderActions } from '../redux/reducers/order';
import { profileActions } from '../redux/reducers/userProfile';
import axios from 'axios';

const { Link } = Typography;

const Checkout = (props) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const stripe = useStripe();
    const elements = useElements();

    const user = useSelector(state => state.user)

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    const [havePromo, setHavePromo] = useState(false);
    const [promoCode, setPromoCode] = useState(null);

    const {product} = props;

    const handleSubmit = async(event)=>{
        event.preventDefault();

        setLoading(true);
        setError(false);
        const {errorPayMeth, paymentMethod} = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement)

        })
        let promoId = null
        let promoError = false
        if(havePromo && promoCode && promoCode !== ""){
          await instance(user.jwt).post("/orders/checkpromo", { promoCode: promoCode })
                                                            .then(resp =>{
                                                                    promoId = resp.data
                                                              })
                                                              .catch(function (error) {
                                                                  setError(true);
                                                                  promoError = true
                                                                  errorModal(error.response.data.message);
                                                                  setLoading(false);
                                                              })
        }

        if(!promoError){
          if(!paymentMethod){
            setError(true);
            errorModal("Check your card details.");
            setLoading(false);
          } else {
            if (errorPayMeth) {
              setError(true);
              errorModal(errorPayMeth.message);
              setLoading(false);
          } else {
              const {id} = paymentMethod
              const resp = await instance(user.jwt).post("/orders", {
                                                      productId: product.id,
                                                      productType: product.type,
                                                      promoCode: promoId ? promoId : null,
                                                      payment: id
                                                  })
                                                  .catch(function (error) {
                                                      setError(true);
                                                      errorModal(error.response.data.message);
                                                      setLoading(false);
                                                  })
  
              if(resp){
                  const {client_secret, status} = resp.data;
      
                  if (status === 'requires_action') {
                      stripe.confirmCardPayment(client_secret).then(function(result) {
                        if (result.error) {
                          console.log('There was an issue!');
                          console.log(result.error);
                          setError(true);
                          errorModal(result.error.message);
                          setLoading(false);
                        } else {
                          setSuccess(true);
                          setError(false);
                          setLoading(false);
                          successModal();
                        }
                      });
                    } else {
                      setSuccess(true);
                      setError(false);
                      setLoading(false);
                      successModal();
                    }
              }
  
          }
          }
        }
        
    }

      function successModal() {
        Modal.success({
            title: 'Payment was successful.',
            content: (
              <div>
                <p>Thank you for being with us!</p>
                <p>You might need to relogin into the system.</p>
                <p>If You have any questions contact us.</p>
              </div>
            ),
            onOk() {
              dispatch(profileActions.getProfile(user.jwt))
              dispatch(orderActions.getOrders(user.jwt))
              history.push("/");
            }, 
          });
      }
      
      function errorModal(message) {
        Modal.error({
            title: 'There was an issue',
            content: (
              <div>
                <p>{message}</p>
              </div>
            ),
            onOk() {},
          });
      }


    return (
        <>
        <form>
                 <CardElement />
            {
                loading ?
                    <Row justify="center"><Spin></Spin></Row>
                : <>
                
                  <Link onClick={() => setHavePromo(!havePromo)} >
                    Got PROMO
                  </Link>

                  <Input style={{ marginTop:"10px", 
                    boxShadow: "rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px",
                    border: "0px"
                  }} 
                    value={promoCode} 
                    placeholder="Enter Promo"
                    onChange={evt => setPromoCode(evt.target.value)} hidden={!havePromo}/>

                    <Button onClick={handleSubmit}
                    style={{ marginTop:"10px"}}
                    block
                    type="primary" disabled={!stripe || loading}>
                        Purchase
                    </Button>
                </>
            }
        </form>
        </>
    )
}

export default Checkout
